<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="py_code,py_emname,py_dpname"
      placeholder="输入单据编号、人员、部门进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/sale/planyear/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.py_code}}</p>
          <p class="list-item-muted">{{item.py_emname}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.py_total}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.py_status!='已审核'}"
          >{{item.py_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('py_total')}}</em>
    </div>
    <!-- <add-button to="/sale/planyear_edit" /> -->
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
// import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    // AddButton
  },
  mixins: [list],
  data() {
    return {
      params: {
        caller: 'PlanYear'
      },
      listUrl: "/api/sale/planyear/list",
      filters: [
        {
          type: "date",
          name: "py_year"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              mode: "MAIN"
            },
            {
              value: 1,
              label: "待审核",
              condition: "py_status<>'已审核'",
              mode: "MAIN"
            },
            {
              value: 2,
              label: "已审核",
              condition: "py_status='已审核'",
              mode: "MAIN"
            }
          ]
        }
      ]
    };
  }
};
</script>